import { useState } from 'react';
import { Routes, Route, BrowserRouter  } from 'react-router-dom';
// components
import SightseeingInfo from './components/sightseeing-info';
import Map from './components/map';
import Header from './components/header';
// css
import './css/style.css';
import './App.css';
import { Sightseeing } from './types/sightseeing';


function App(  props: { config: any, handler: any } ) {
  const [ isOpenPrefecture, setIsOpenPrefecture ] = useState<boolean>(false); // 1:都道府県ダイアログ
  const [ isSettingDisplay, setIsSettingDisplay ] = useState<boolean>(true); // 2:設定表示非表示フラグ
  const [ selectSightseeing, setSelectSightseeing ] = useState<Sightseeing | null>(); // 3:観光選択
  const [ selectPrefecture, setSelectPrefecture ] = useState<number | null>(null); // 4:都道府県選択
  const { config, handler } = props;

  return (
    <div className="App">
        <BrowserRouter>
            <Header
              setIsOpenPrefecture={setIsOpenPrefecture} // 1:都道府県ダイアログ
              isSettingDisplay={isSettingDisplay} // 2:設定表示非表示フラグ
              setSelectSightseeing={setSelectSightseeing}  // 3:観光選択
            />
            <Routes>
              <Route path="/" element={ 
                <Map 
                  config={config}
                  handler={handler}
                  isOpenPrefecture={isOpenPrefecture} // 1:都道府県ダイアログ
                  setIsOpenPrefecture={setIsOpenPrefecture} // 1:都道府県ダイアログ
                  setIsSettingDisplay={setIsSettingDisplay} // 2:設定表示非表示フラグ
                  selectSightseeing={selectSightseeing} // 3:観光選択
                  setSelectSightseeing={setSelectSightseeing} // 3:観光選択
                  selectPrefecture={selectPrefecture} // 4:都道府県選択
                  setSelectPrefecture={setSelectPrefecture} // 4:都道府県選択
                />
              } />
              <Route path="/sightseeing" element={ 
                <SightseeingInfo 
                  config={config}
                  setIsSettingDisplay={setIsSettingDisplay} // 2:設定表示非表示フラグ
                  setSelectSightseeing={setSelectSightseeing} // 3:観光選択
                  selectPrefecture={selectPrefecture} // 4:都道府県選択
                  setSelectPrefecture={setSelectPrefecture} // 4:都道府県選択
                /> 
              } />
            </Routes>
        </BrowserRouter>
    </div>
  );
}

export default App;
